import { gql } from '@apollo/client';

const Fragments = {
  checklistItem: gql`
    fragment checklistItem on ChecklistItem {
      id
      reqDocTypeId
      targetAreaId
      documentName
      documentCode
      sharePointContentType
      mandatoryYN
      defaultYN
      filterCondition
      targetAreaName
      flowId
      postUploadStateId
      validityDays
      canExpire
    }
  `,
  checklistFilter: gql`
    fragment checklistFilter on ChecklistFilter {
      filterId
      docTypeAreaId
      paramId
      operatorId
      orderNo
      filterValue
      filterValueId
      paramName
      operatorName
      paramIsList
      operatorIsMultipleSelection
    }
  `,
  checklistFilterValue: gql`
    fragment checklistFilterValue on ChecklistFilterValue {
      valueId
      filterId
      filterValue
      filterValueId
    }
  `,
  checklistProperty: gql`
    fragment checklistProperty on ChecklistProperty {
      requiredDocTypeId
      propertyId
      mandatory
      defaultValue
    }
  `,
  checklistPropertiesItem: gql`
    fragment checklistPropertiesItem on ChecklistPropertiesItem {
      propertyId
      propertyCode
      propertyName
      propertyTypeId
      readOnly
    }
  `,
  checklistXUserGroupItem: gql`
    fragment checklistXUserGroupItem on ChecklistXUserGroup {
      requiredDocTypeId
      userGroupId
    }
  `
};

export default Fragments;
